
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7082/api/',
    //Live

    //DEV


    // Demo
    apiUrl: 'https://m-api-test.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

